import { ReactElement } from 'react';

const THUMBNAIL_PLACEHOLDERS = ['product-thumb-1', 'product-thumb-2', 'product-thumb-3'] as const;

export default function ProductThumbnailPlaceholders({ className }: { className: string }): ReactElement {
	return (
		<div className='grid grid-cols-3 gap-3'>
			{THUMBNAIL_PLACEHOLDERS.map((id) => (
				<div key={id} className={`rounded bg-[#46506A] ${className}`} />
			))}
		</div>
	);
}
